import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/members',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/MembersContainer',
      './modules/members'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Members = require('./containers/MembersContainer').default
      const actions = require('./modules/members')
      const reducer = require('./modules/members').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'members', reducer: reducer })

      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, Members)

    /* Webpack named bundle   */
    }, 'members')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Members/index.js